// extracted by mini-css-extract-plugin
module.exports = {"gradientTitle":"HoverMagic_gradientTitle__MYR3M"};